import { mapActions } from 'vuex'

export default {
    template: '<router-view />',

    // beforeRouteEnter(to, from, next) {
    //     next(vm => {
    //         vm.fetch()
    //     })
    // },

    methods: {
        ...mapActions({
            // fetch: 'widget/fetch',
        }),
    }
}